<template>
  <div class="content">
     <el-row style="height: 4vh; padding-left: 0.5vw; padding-top: 0.1vh;">
      <el-col :span="24" style="margin:0;">
        <div class="grid-content1 bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>物资管理</el-breadcrumb-item>
            <el-breadcrumb-item>材料抽检</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div class="content-container">
      <div class="container-top">
        <div style="width: 50%;text-align: left;">
          <el-input size="small" v-model="search.orderNumber" clearable placeholder="请输入订单编号" style="margin-right: 1vw;"></el-input>
          <el-button size="small" type="primary" @click="select">查询</el-button>
        </div>
        <div>
          <!-- <el-button size="small" type="primary">导出表单</el-button> -->
          <el-button size="small" type="primary" @click="toRecord">抽查记录</el-button>
        </div>
      </div>
      <!-- <div class="title">材料抽检</div> -->
      <el-table height="74vh" stripe :data="tableData">
        <el-table-column label="序号">
          <template slot-scope="scope">
            <span>{{scope.row.index}}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单编号">
          <template slot-scope="scope">
            <span>{{scope.row.orderNumber}}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请人">
          <template slot-scope="scope">
            <span>{{scope.row.createName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="入库时间">
          <template slot-scope="scope">
            <span>{{scope.row.createDate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="审批人">
          <template slot-scope="scope">
            <span>{{scope.row.handlerName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="检测机构">
          <template slot-scope="scope">
            <span>{{scope.row.testingOrganization}}</span>
          </template>
        </el-table-column>
        <el-table-column label="检测结果">
          <template slot-scope="scope">
            <!-- <span>{{scope.row}}</span> -->
            <span v-if="scope.row.handlerStatus == 1" style="color: green;">合格</span>
            <span v-else-if="scope.row.handlerStatus == 2" style="color: red;">不合格</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column label="检测报告">
          <template slot-scope="scope">
            <el-button type="text" style="color: #2E5BE9;text-decoration: underline;" @click="lookFile(scope.row)">点击查看</el-button>
          </template>
        </el-table-column>
        <el-table-column label="检测时间">
          <template slot-scope="scope">
            <span>{{scope.row.handlerDate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" style="color: #2E5BE9;" @click="toStock(scope.row)">抽查</el-button>
            <el-button type="text" style="color: #2E5BE9;" :disabled="!scope.row.samplingId" @click="toLook(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
       <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="1"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
    </div>
    <!-- 抽查弹出框 -->
    <el-dialog
      :visible.sync="dialog"
       width="50%"
       center
    >
      <el-table :data="spotCheckData" stripe max-height="35vh" @selection-change="handleSelectionChange">
         <el-table-column  type="selection" width="55"></el-table-column>
         <el-table-column label="材料名称">
           <template slot-scope="scope">
             <span>{{ scope.row.materialName }}</span>
           </template>
         </el-table-column>
         <el-table-column label="材料型号">
           <template slot-scope="scope">
             <span>{{ scope.row.materialModel }}</span>
           </template>
         </el-table-column>
         <el-table-column label="材料品牌">
           <template slot-scope="scope">
             <span>{{ scope.row.materialBrand }}</span>
           </template>
         </el-table-column>
         <el-table-column label="生产厂家">
           <template slot-scope="scope">
             <span>{{ scope.row.materialManufacturer }}</span>
           </template>
         </el-table-column>
         <el-table-column label="供应商名称">
           <template slot-scope="scope">
             <span>{{ scope.row.materialSupplier }}</span>
           </template>
         </el-table-column>
         <el-table-column label="数量">
           <template slot-scope="scope">
             <span>{{ scope.row.amount }}{{ scope.row.materialUnitTypeName }}</span>
           </template>
         </el-table-column>
      </el-table>
      <div style="margin: 2vh 0;">
        <span class="letter">材料是否合格</span>：
        <el-radio-group v-model="handlerStatus" >
          <el-radio :label="1" :disabled="isLook">合格</el-radio>
          <el-radio :label="2" :disabled="isLook">不合格</el-radio>
        </el-radio-group>
      </div>
      <div>
        <span class="letter">检测机构</span>：
        <el-input size="media" v-model="testingOrganization" :disabled="isLook" placeholder="请输入机构名称"></el-input>
      </div>
      <div style="display: flex;margin-top: 2vh;align-items: center;" v-show="!isLook">
        <span class="letter">上传检测报告</span>：
        <div style="display: flex;width: 70%;">
          <div v-if="fileList.length" style="display: flex;flex-wrap:wrap;width: 70%">
            <div v-for="(file, index) in fileList" :key="index" style="display: flex;;align-items: center;">
              <img :src="getFileType(file.type)"  style="width: 45px;height: 45px;cursor: pointer;"/>
              <p style="margin:10px 20px;cursor: pointer;">{{file.name}}</p>
              <el-button size="mini" type="danger" @click="deleteFile(file.name)">删除</el-button>
            </div>
        </div>
        <el-upload
          :style="{'margin-left': fileList.length > 0? '20px' : '0'}"
          ref="upload"
          class="upload-demo"
          :action="uploadUrl"
          :data="{type: 253}"
          :headers="uploadHead"
          :on-success="handleSuccess"
          :limit="1"
          :on-exceed="handleExceed"
          >
          <span class="el-icon-plus"></span>
        </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-show="!isLook">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import base from '../../untils/base'
  import util from '../../untils/util'
  import myHttp from '../../untils/port'
  export default {
    data() {
      return {
        projectId: '',
        pageSize: 20,
        pageNum: 1,
        total: 0,
        search: {
          orderNumber: ''
        },
        tableData: [],
        spotCheckData: [],   // 弹出框的数据
        dialog: false,
        fileList: [],
        uploadUrl:base.url + "/upload/uploadPhoto",//上传地址
        uploadHead:{      //上传接口header
          accessToken: this.$store.state.token
        },
        examiningReport: '',
        testingOrganization: '',  //  检测机构
        handlerStatus: '',     // 合格状态  1合格   2不合格
        supplierStorageId: '',
        supplierVos: [],
        isLook: false
      }
    },
    created() {
      this.projectId = util.session.get('groupId')
      this.getData()
    },
    methods: {
      select(){
        this.pageSize = 20
        this.pageNum = 1
        this.getData()
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getData()
      },
      getData(){
        myHttp.findMaterialSamplingPage({
          projectId: this.projectId,
          time: '',
          createName: '',
          orderNumber: this.search.orderNumber,
          pageSize: this.pageSize,
          pageNum: this.pageNum
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            const list = resp.data.data.materialSamplingPage.list || []
            list.forEach((item, index) => {
              item.index = (this.pageNum - 1) * this.pageSize + 1 + index
            })
            this.tableData = list
            this.total = resp.data.data.materialSamplingPage.total
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      // 打开去抽查弹窗
      toStock(row){   
        this.handlerStatus = ''
        this.testingOrganization = ''
        this.isLook = false
        this.supplierStorageId = row.supplierStorageId
        myHttp.findProjectSupplierStorageList({
          storageId: row.supplierStorageId
        }).then(resp => {
          if(resp.data.code === 200){
            this.spotCheckData = resp.data.data.projectSupplierStorageList || []
          }else{
            this.$message.error(resp.data.msg)
          }
          this.dialog = true
        })
      },
      // 表格多选
      handleSelectionChange(val){
        this.supplierVos = []
        let obj = {}
        val.forEach(item => {
          obj.supplierId = item.supplierId
          this.supplierVos.push(JSON.parse(JSON.stringify(obj)))
        })
      },
      // 限制只能上传一个
      handleExceed(files, fileList){
        this.$message.warning('只能上传一个文件哦！！')
      },
      // 文件上传成功的钩子
      handleSuccess(resp, file, fileList){
        console.log(resp);
        console.log(file);
        console.log(fileList);
        if(resp.code === 200){
           let obj = {}
           const url = resp.data.saveUrls
           this.examiningReport = this.examiningReport + ',' + url
           const type = url.split('.')[1]
           obj.type = type
           obj.name = file.name
           this.fileList.push(JSON.parse(JSON.stringify(obj)))
           console.log(this.examiningReport);
           this.$refs.upload.clearFiles()   // 上传成功之后清除记录
        }else{
          this.$message.error(resp.data.msg)
        }
      },
      // 查看文件
      lookFile(row){
        window.open('http://view49.tongsheng01.com/onlinePreview?url=' + base.httpCtx +row.examiningReport)
      },
      // 获取文件类型
      getFileType(type){
        let result = ''
        if (base.docType.indexOf(type) >= 0) {
            result = require('../../assets/image/office/word.png')
          } else if (base.imgType.indexOf(type) >= 0) {
            result = require('../../assets/image/office/photo.png')
          } else if (base.excelType.indexOf(type) >= 0) {
            result = require('../../assets/image/office/excel.png')
          } else if (base.pdfType.indexOf(type) >= 0) {
            result = require('../../assets/image/office/pdf.png')
          } else if (base.zipType.indexOf(type) >= 0) {
            obj.fileType = require('../../assets/image/office/zip.png')
          } else {
            result = require('../../assets/image/office/undefined.png')
          }
          return result
      },
      // 删除文件
      deleteFile(name){
        for(let i=0;i<this.fileList.length;i++){
          if(this.fileList[i].name == name){
            this.fileList.splice(i, 1)
          }
        }
      },
      // 提交
      submit(){
        this.examiningReport = this.examiningReport.slice(1)
        myHttp.materialSampling({
          examiningReport: this.examiningReport,
          testingOrganization: this.testingOrganization,
          handlerStatus: this.handlerStatus,
          supplierStorageId: this.supplierStorageId,
          supplierVos: this.supplierVos
        }).then(resp => {
          if(resp.data.code === 200){
            this.$message.success('操作成功！！')
            this.dialog = false
            this.examiningReport = ''
            this.testingOrganization = ''
            this.handlerStatus = ''
            this.supplierVos = ''
            this.fileList = []
            this.getData()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      // 查看
      toLook(row){
        console.log(row);
        this.isLook = true
        myHttp.findProMaterialSamplingSupplierList({
          samplingId: row.samplingId
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            this.dialog = true
            this.spotCheckData = resp.data.data.proMaterialSamplingSupplierList || []
            this.handlerStatus = parseInt(row.handlerStatus)
            this.testingOrganization = row.testingOrganization
            // this.
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      // 去抽查记录
      toRecord(){
        this.$router.push({
          path: '/spotCheckRecord'
        })
      }
    },
  }
</script>

<style scoped>
.content-container{
  height: 85vh;
  background-color: #fff;
  border-radius: 6px;
}
.container-top{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1vh 1vw;
  /* margin-bottom: 1vh; */
  border-bottom: 1px solid #EBEEF5;
}
.el-button--primary{
  background-color: #0b62f0;
  border-radius: 6px;
}
.el-input{
  width: 12vw;
}
.title{
  width: 100%;
  height: 60px;
  color: #333;
  font-weight: 900;
  font-size: 1.2vw;
  background-color: #E6E6E6;
  line-height: 60px;
  letter-spacing: 8px;
}
.el-pagination{
  background-color: #E6E6E6;
  padding: 10px 0!important;
  border-radius: 0 0 6px 6px;
}
.letter{
  display: inline-block;
  width: 6vw;
  text-align-last: justify;
}
.upload-demo{
  width: 39px;
  height: 39px;
  border: 1px solid #ccc;
  text-align: center;
  line-height: 39px;
}
.el-icon-plus{
  font-size: 20px;
  color: #D0D0D0;
}
/deep/ .el-upload-list__item{
  display: none;
}

/deep/ .el-dialog__headerbtn{
  display: none;
}
.content >>> .el-table th.el-table__cell>.cell{
  font-size: 18px;
  font-family: Microsoft YaHei;
}
.content >>> .el-table th.el-table__cell>.cell span{
  font-size: 16px !important;
}
::v-deep .cell>span{
font-size: 16px !important;
}
</style>